<template>
  <v-card class="mx-auto rounded-card">
    <v-tabs v-model="tab">
      <v-tab>Detalhes</v-tab>
      <v-tab v-if="checkRoles">Notificações</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item>
        <v-card class="rounded-card"
                flat>
          <v-card-text>
            <px-minha-conta-tab-detalhes :user="user" :loading="loading"/>
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card class="rounded-card"
                flat>
          <v-card-text>
            <px-minha-conta-tab-config-notificacao :user="user" :loading="loading"/>
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
import MinhaContaTabDetalhes from './tabs/MinhaContaTabDetalhes.vue';
import MinhaContaTabConfigNotificacao from './tabs/MinhaContaTabConfigNotificacao.vue';

export default {
  props: {
    user: Object,
    loading: Boolean,
  },
  computed: {
    ...mapGetters('user', ['hasModuleGerencia', 'hasRoleGestorCompras', 'hasRoleAprovador', 'hasRoleRequisicao']),
    tab: {
      get() {
        return this.$store.getters['minhaConta/tab'];
      },
      set(searchText) {
        this.$store.dispatch('minhaConta/tab', searchText);
      },
    },
    checkRoles() {
      return this.hasModuleGerencia || this.hasRoleGestorCompras || this.hasRoleAprovador
        || this.hasRoleRequisicao;
    },
  },
  methods: {
    emitUpdate() {
      this.$emit('update');
    },
  },
  components: {
    pxMinhaContaTabDetalhes: MinhaContaTabDetalhes,
    pxMinhaContaTabConfigNotificacao: MinhaContaTabConfigNotificacao,
  },
};
</script>
